import type { ProjectDocument } from "../../types/documents";

export type SourcesTabKey = "scopes" | "project_docs" | "emails_notes";

export const tabToDocumentTypes: Record<SourcesTabKey, string[]> = {
    scopes: ["baseline"],
    project_docs: ["project_doc"],
    emails_notes: ["email_digest", "meeting_notes"],
};

export const deriveTitleFromFileName = (fileName: string): string => {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) return fileName;
    return fileName.slice(0, dotIndex);
};

export const mapTabToLabel: Record<SourcesTabKey, string> = {
    scopes: "Baseline",
    project_docs: "Project Documents",
    emails_notes: "Emails & Notes",
};

export const mapTabToHelperText: Record<SourcesTabKey, string> = {
    scopes:
        "Drop your baseline scope or contract so ScopeShield knows what you actually agreed to.",
    project_docs: "Upload plan sets, addenda, and supporting project documents.",
    emails_notes:
        "Add email summaries and meeting notes so ScopeShield can catch creep hiding in the conversation.",
};

export const filterDocumentsForTab = (
    documents: ProjectDocument[],
    tab: SourcesTabKey,
): ProjectDocument[] => {
    if (tab === "scopes") {
        return documents.filter((doc) => doc.type === "baseline");
    }

    if (tab === "project_docs") {
        return documents.filter((doc) => doc.type === "project_doc");
    }

    if (tab === "emails_notes") {
        return documents.filter((doc) =>
            ["email_digest", "meeting_notes"].includes(doc.type ?? ""),
        );
    }

    return documents;
};
